import angular, { IChangesObject, IOnChangesObject } from 'angular';
import './tag.styles.scss';

export const TagComponent = {
  selector: 'tag',
  restrict: 'E',
  bindings: {
    color: '@',
    text: '@?',
    hover: '@?',
  },
  template: /* html */ `
    <div class="tag" ng-class="$ctrl.calculatedColor">
      <span ng-if="$ctrl.text">{{ $ctrl.text }}</span>
      <div ng-transclude class="transclude-wrap"></div>
      
      <div ng-if="$ctrl.hover && $ctrl.hover !== ''" class="transclude-wrap">
        <svg class="ab-icon"><use xlink:href="#info-light"></use></svg>
        <div class="hover-content">
          <span>{{ $ctrl.hover }}</span>
        </div>
      </div>
    </div>
  `,
  transclude: true,
  controller: class TagController {
    private text = '';

    private color = '';

    private hover = '';

    public calculatedColor = '';

    private numberConversionService: any;

    constructor(numberConversionService: any) {
      'ngInject';

      this.numberConversionService = numberConversionService;
    }

    // Either the color is provided explicitly or is calculated based on the provided text,
    // so that it is the same everytime.
    $onChanges(): void {
      this.calculatedColor = '';

      if (this.color === '' || this.color === undefined) {
        const randomDigit = this.numberConversionService.randomNumberWithSeed(this.text, 9);

        switch (randomDigit) {
          case 1:
          case 9:
            this.calculatedColor = 'blue';
            break;

          case 2:
          case 4:
            this.calculatedColor = 'orange';
            break;

          case 6:
          case 8:
            this.calculatedColor = 'green';
            break;

          case 3:
          case 7:
            this.calculatedColor = 'red';
            break;

          case 0:
          case 5:
          default:
            this.calculatedColor = 'grey';
            break;
        }
      } else {
        this.calculatedColor = this.color;
      }
    }
  },
};

export default angular.module('components.tag', [])
  .component(TagComponent.selector, TagComponent)
  .name;
